<template>
  <div class="productPage">
    <div class="aBox1">
      <img class="ab1Img" src="http://cdn.xiyundata.com/crane_index/version3/v3product01.png" alt="" />
      <img class="ab1Img2" src="http://cdn.xiyundata.com/crane_index/version3/v3product02.png" alt="" />
    </div>
    <div class="aBox2">
      <div class="aBox2Content">
        <div class="ab2Tit">产品服务</div>
        <div class="ab2Eng">PRODUCT CAPABILITY</div>
        <div class="ab2Main">
          <div class="amLeft">
            <div class="amItem1" :class="pacActive == 1 ? 'actItemBox' : ''" @click="changeActive(1)">
              <div class="amiTitle" :class="pacActive == 1 ? 'actItemTitle' : ''">无线动态应变仪</div>
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product04.png" alt="" class="amiImg01">
              <img v-if="pacActive == 1" class="jiantouSty"
                src="http://cdn.xiyundata.com/crane_index/version3/v3RedJiantou.png" alt="">
              <img v-else class="jiantouSty" src="http://cdn.xiyundata.com/crane_index/version3/v3GrayJiantou.png"
                alt="">
            </div>
            <div class="amItem2" :class="pacActive == 4 ? 'actItemBox' : ''" @click="changeActive(4)">
              <div class="amiTitle" :class="pacActive == 4 ? 'actItemTitle' : ''">自研应力监测平台</div>
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product03.png" alt="" class="amiImg02">
              <img v-if="pacActive == 4" class="jiantouSty"
                src="http://cdn.xiyundata.com/crane_index/version3/v3RedJiantou.png" alt="">
              <img v-else class="jiantouSty" src="http://cdn.xiyundata.com/crane_index/version3/v3GrayJiantou.png"
                alt="">
            </div>
          </div>
          <div class="amRight">
            <div class="amItem3" :class="pacActive == 2 ? 'actItemBox' : ''" @click="changeActive(2)">
              <div class="amiTitle" :class="pacActive == 2 ? 'actItemTitle' : ''">焊接式应变计</div>
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product02Pic.png" alt="" class="amiImg03">
              <img v-if="pacActive == 2" class="jiantouSty"
                src="http://cdn.xiyundata.com/crane_index/version3/v3RedJiantou.png" alt="">
              <img v-else class="jiantouSty" src="http://cdn.xiyundata.com/crane_index/version3/v3GrayJiantou.png"
                alt="">
            </div>
            <div class="amItem4" :class="pacActive == 3 ? 'actItemBox' : ''" @click="changeActive(3)">
              <div class="amiTitle" :class="pacActive == 3 ? 'actItemTitle' : ''">应力采集网关</div>
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product01Pic.png" alt="" class="amiImg04">
              <img v-if="pacActive == 3" class="jiantouSty"
                src="http://cdn.xiyundata.com/crane_index/version3/v3RedJiantou.png" alt="">
              <img v-else class="jiantouSty" src="http://cdn.xiyundata.com/crane_index/version3/v3GrayJiantou.png"
                alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pBox3">
      <div class="pBox3Content">
        <div class="pb3Tit">产品介绍</div>
        <div class="pb3Eng">PRODUCT INTRODUCTION</div>
        <div id="infoBox1" class="proInfo1">
          <div class="in1Top">无线动态应变仪</div>
          <div class="in1Main">
            <div class="i1Left">
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product04.png" alt="">
            </div>
            <div class="i1Right">
              <div class="i1rName">详细参数</div>
              <div class="i1rLine1">
                <div class="rl1Left">处理器：</div>
                <div class="rl1Right">MTK8788 处理器/8核/8线程/主频2.0GHz</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left">内存/存储：</div>
                <div class="rl1Right">8G/128G</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left">通讯：</div>
                <div class="rl1Right">WiFi(2.4/5Ghz) /zigbee3.0</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left">电池性能：</div>
                <div class="rl1Right">锂电池/3.8V/12000mAh/11小时</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left">显示屏：</div>
                <div class="rl1Right">10.1英寸LCD屏 分辨率1920×1200, 560nits</div>
              </div>
              <div class="i1rLine1" style="margin-bottom: 0px;border-bottom: none;">
                <div class="rl1Left">软件：</div>
                <div class="rl1Right">数港监测v1.0</div>
              </div>
            </div>
          </div>
        </div>
        <div id="infoBox2" class="proInfo1">
          <div class="in1Top">自研应力监测平台</div>
          <div class="in1Main">
            <div class="i1Left">
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product02Pic.png" alt="">
            </div>
            <div class="i1Right">
              <div class="i1rName" style="margin-bottom: 39px;">详细参数</div>
              <div class="i1rLine1">
                <div class="rl1Left" style="line-height: 1.5;">产品特点：</div>
                <div class="rl1Right" style="line-height: 1.5;height: 60px;">实时和完全集成的数据库，主动监督和监控系统，振动分析报告<br />一目了然
                </div>
              </div>
              <div class="i1rLine1" style="margin-bottom: 0px;border-bottom: none;">
                <div class="rl1Left" style="line-height: 2;">系统要求：</div>
                <div class="rl1Right" style="height: 200px;line-height: 2;">Intel Core i5 、 Intel Core i7<br />Windows
                  10（32 位和 64 位）、Windows 11<br />8GB RAM<br />10 GB 磁盘空间<br />1 GB 图形内存</div>
              </div>
            </div>
          </div>
        </div>
        <div id="infoBox3" class="proInfo1">
          <div class="in1Top">应力采集网关</div>
          <div class="in1Main">
            <div class="i1Left">
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product01Pic.png" alt="">
            </div>
            <div class="i1Right">
              <div class="i1rName" style="margin-bottom: 24px;">详细参数</div>
              <div class="i1rLine1">
                <div class="rl1Left leftLine">测量范围：</div>
                <div class="rl1Right">MTK8788 处理器/8核/8线程/主频2.0GHz</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left leftLine">通道数：</div>
                <div class="rl1Right">1通道</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left leftLine">最大无限范围：</div>
                <div class="rl1Right">650 米 （视线） 30-100 米 （非视线）</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left leftLine">采样频率/数据量：</div>
                <div class="rl1Right">每秒 400 个样本（16 位 ADC）/100 万个数据点</div>
              </div>
              <div class="i1rLine1">
                <div class="rl1Left leftLine">工作温度：</div>
                <div class="rl1Right">-40°C 至 +65°C</div>
              </div>
              <div class="i1rLine1" style="margin-bottom: 0px;border-bottom: none;">
                <div class="rl1Left leftLine">材料尺寸：</div>
                <div class="rl1Right rightLine" style="line-height: 1.5;font-size: 12px;">防水 IP67外壳尺寸（不含天线）156 mm x 82
                  mm x 57 mm 铝壳，重量 760g</div>
              </div>
            </div>
          </div>
        </div>
        <div id="infoBox4" class="proInfo2">
          <div class="in2Top">焊接式应变计</div>
          <div class="in2Main">
            <div class="i2Left">
              <img src="http://cdn.xiyundata.com/crane_index/version3/v3product03.png" alt="">
            </div>
            <div class="i2Right">
              <div class="i2rName">详细参数</div>
              <div class="i2rLine1">
                <div class="rl2Left">敏感栅材料：</div>
                <div class="rl2Right">康铜</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">基底材料：</div>
                <div class="rl2Right">特种聚酰亚胺</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">基础体材料：</div>
                <div class="rl2Right">不锈钢</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">基础体厚度(mm)：</div>
                <div class="rl2Right">0.1</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">典型电阻值(Ω)：</div>
                <div class="rl2Right">120、350</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">电阻值公差：</div>
                <div class="rl2Right">≤±0.1%</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">典型灵敏系数：</div>
                <div class="rl2Right">1.80 ～2.2</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">灵敏系数分散：</div>
                <div class="rl2Right">≤±2%</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">使用温度范围：</div>
                <div class="rl2Right">-30℃～+150℃</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">应变极限：</div>
                <div class="rl2Right">±3000με</div>
              </div>
              <div class="i2rLine1">
                <div class="rl2Left">防护方式：</div>
                <div class="rl2Right">硅胶防护</div>
              </div>
              <div class="i2rLine1" style="margin-bottom: 0px;border-bottom: none;">
                <div class="rl2Left">安装方式：</div>
                <div class="rl2Right">点焊安装</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pacActive: 1,
    };
  },
  methods: {
    handleScroll() {
      // 淡入动画
      // const pBox4 = this.$el.querySelector(".pBox4");
      // const pBox4Top = pBox4.offsetTop;
      // const windowHeight = window.innerHeight;
      // const scrollPosition =
      //   window.pageYOffset || document.documentElement.scrollTop;

      // if (
      //   scrollPosition + windowHeight > pBox4Top &&
      //   scrollPosition < pBox4Top + pBox4.offsetHeight
      // ) {
      //   pBox4.classList.add("fade-in-animation");
      // } else {
      //   pBox4.classList.remove("fade-in-animation");
      // }

      // const pBox5 = this.$el.querySelector(".pBox5");
      // const pBox5Top = pBox5.offsetTop;
      // if (
      //   scrollPosition + windowHeight > pBox5Top &&
      //   scrollPosition < pBox5Top + pBox5.offsetHeight
      // ) {
      //   pBox5.classList.add("fade-in-animation");
      // } else {
      //   pBox5.classList.remove("fade-in-animation");
      // }

      // const pBox6 = this.$el.querySelector(".pBox6");
      // const pBox6Top = pBox6.offsetTop;
      // if (
      //   scrollPosition + windowHeight > pBox6Top &&
      //   scrollPosition < pBox6Top + pBox6.offsetHeight
      // ) {
      //   pBox6.classList.add("fade-in-animation");
      // } else {
      //   pBox6.classList.remove("fade-in-animation");
      // }

      // const pBox7 = this.$el.querySelector(".pBox7");
      // const pBox7Top = pBox7.offsetTop;
      // if (
      //   scrollPosition + windowHeight > pBox7Top &&
      //   scrollPosition < pBox7Top + pBox7.offsetHeight
      // ) {
      //   pBox7.classList.add("fade-in-animation");
      // } else {
      //   pBox7.classList.remove("fade-in-animation");
      // }

      // const pBox8 = this.$el.querySelector(".pBox8");
      // const pBox8Top = pBox8.offsetTop;
      // if (
      //   scrollPosition + windowHeight > pBox8Top &&
      //   scrollPosition < pBox8Top + pBox8.offsetHeight
      // ) {
      //   pBox8.classList.add("fade-in-animation");
      // } else {
      //   pBox8.classList.remove("fade-in-animation");
      // }

      // const pBox9 = this.$el.querySelector(".pBox9");
      // const pBox9Top = pBox9.offsetTop;
      // if (
      //   scrollPosition + windowHeight > pBox9Top &&
      //   scrollPosition < pBox9Top + pBox9.offsetHeight
      // ) {
      //   pBox9.classList.add("fade-in-animation");
      // } else {
      //   pBox9.classList.remove("fade-in-animation");
      // }

    },
    changeActive(no) {
      this.pacActive = no
      // 获取目标元素的 ID
      const targetId = `infoBox${no}`;
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // 使用 scrollIntoView 方法滚动到目标元素
        targetElement.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "start" // 滚动到元素的顶部
        });
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.productPage {
  /* padding-top: 70px; */
}

.aBox1 {
  width: 100vw;
}

.ab1Img {
  width: 100%;
}

.ab1Img2 {
  width: 100%;
}

.aBox2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 1080px;
  box-sizing: border-box;
  background: #F5F5F7;
}

.aBox2Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  height: 100%;
  padding-top: 42px;
  box-sizing: border-box;
}

.ab2Tit {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
  margin-bottom: 5px;
}

.ab2Eng {
  font-weight: 400;
  font-size: 14px;
  color: #99999A;
  line-height: 20px;
  margin-bottom: 61px;
}

.ab2Main {
  display: flex;
  justify-content: space-between;
  height: 867px;
  width: 100%;
}

.amLeft {
  width: 604px;
  height: 100%;
}

.amRight {
  width: 588px;
  height: 100%;
}

.amItem1 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 476px;
  width: 100%;
  margin-bottom: 8px;
  overflow: hidden;
  background-color: #fff;
  opacity: 0.7;
}

.actItemBox {
  opacity: 1 !important;
}

.actItemTitle {
  font-weight: 700 !important;
  font-size: 18px !important;
  color: #DA0010 !important;
  line-height: 26px !important;
}

.amiTitle {
  position: absolute;
  top: 25px;
  left: 25px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 14px;
  color: #C8C8C8;
  line-height: 20px;
}

.jiantouSty {
  position: absolute;
  right: 30px;
  bottom: 30px;
  width: 50px;
  height: 50px;
}

.amiImg01 {
  width: 473px;
  height: 472px;
}

.amiImg02 {
  width: 436px;
  height: 344px;
}

.amiImg03 {
  width: 302px;
  height: 302px;
}

.amiImg04 {
  width: 284px;
  height: 284px;
}

.amItem2 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 383px;
  overflow: hidden;
  background-color: #fff;
  opacity: 0.7;
}

.amItem3 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 428px;
  margin-bottom: 8px;
  overflow: hidden;
  background-color: #fff;
  opacity: 0.7;
}

.amItem4 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 431px;
  overflow: hidden;
  background-color: #fff;
  opacity: 0.7;
}

.pBox3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: auto;
  box-sizing: border-box;
  background: #ffffff;
}

.pBox3Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  height: 100%;
  padding-top: 83px;
  box-sizing: border-box;
}

.pb3Tit {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
  margin-bottom: 11px;
}

.pb3Eng {
  font-weight: 400;
  font-size: 14px;
  color: #99999A;
  line-height: 20px;
  margin-bottom: 68px;
}

.proInfo1 {
  width: 100%;
  height: 629px;
  border-bottom: 1px solid #CCCCCC;
  margin-bottom: 51px;
}

.in1Top {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
  margin-bottom: 36px;
}

.in1Main {
  display: flex;
  width: 100%;
  height: 499px;
  background: #F5F5F7;
}

.i1Left {
  height: 100%;
  width: 569px;
  border-right: 1px solid #D8D8D8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.i1Right {
  height: 100%;
  width: 631px;
  padding: 26px 30px 0;
  box-sizing: border-box;
}

.i1rName {
  width: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  color: #33333A;
  line-height: 29px;
  margin-bottom: 44px;
}

.i1rLine1 {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #D8D8D8;
  margin-bottom: 23px;
}

.rl1Left {
  width: 110px;
  height: 46px;
  font-weight: 400;
  font-size: 16px;
  color: #33333A;
}

.leftLine {
  width: 135px;
}

.rl1Right {
  height: 46px;
  font-weight: 700;
  font-size: 16px;
  color: #33333A;
}

.rightLine {
  width: 325px;
}

.proInfo2 {
  width: 100%;
  height: 629px;
  margin-bottom: 100px;
}

.in2Top {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
  margin-bottom: 36px;
}

.in2Main {
  display: flex;
  width: 100%;
  height: 540px;
  background: #F5F5F7;
}

.i2Left {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 569px;
  border-right: 1px solid #D8D8D8;
}

.i2Right {
  height: 100%;
  width: 631px;
  padding: 26px 30px 0;
  box-sizing: border-box;
}

.i2rName {
  width: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  color: #33333A;
  line-height: 29px;
  margin-bottom: 20px;
}

.i2rLine1 {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #D8D8D8;
  margin-bottom: 11px;
}

.rl2Left {
  width: 135px;
  height: 28px;
  font-weight: 400;
  font-size: 12px;
  color: #33333A;
}

.rl2Right {
  height: 28px;
  font-weight: 700;
  font-size: 12px;
  color: #33333A;
}

.fade-in-animation {
  animation: fade-in 1.1s ease-in-out forwards;
}

/* 淡入动画 */
@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* 媒体查询，屏幕宽度小于830px */
@media (max-width: 830px) {
  .ab1Img {
    display: none;
  }

  .ab1Img2 {
    display: block;
  }

  .aBox2 {
    height: auto;
  }

  .aBox2Content {
    width: 100%;
    padding-top: 40px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .ab2Tit {
    font-size: 24px;
  }

  .ab2Eng {
    font-size: 12px;
    margin-bottom: 30px;
  }

  .ab2Main {
    display: block;
    height: auto;
  }

  .amLeft {
    width: 100%;
    height: auto;
  }

  .amItem1 {
    width: 100%;
    height: 350px;
    margin-bottom: 20px;
  }

  .amItem2 {
    width: 100%;
    height: 350px;
    margin-bottom: 20px;
  }

  .amRight {
    width: 100%;
    height: auto;
  }

  .amItem3 {
    width: 100%;
    height: 350px;
    margin-bottom: 20px;
  }

  .amItem4 {
    width: 100%;
    height: 350px;
    margin-bottom: 34px;
  }

  .amiImg01 {
    width: 370px;
    height: 370px;
  }

  .amiImg02 {
    width: 378px;
    height: 300px;
  }

  .amiImg03 {
    width: 302px;
    height: 302px;
  }

  .amiImg04 {
    width: 250px;
    height: 250px;
  }

  .actItemTitle {
    font-size: 16px !important;
  }

  .jiantouSty {
    width: 40px;
    height: 40px;
  }

  .amiTitle {
    top: 18px;
    left: 20px;
  }

  .pBox3Content {
    width: 100%;
    padding-top: 30px;
  }

  .pb3Tit {
    font-size: 24px;
    margin-bottom: 5px;
  }

  .pb3Eng {
    font-size: 12px;
    margin-bottom: 30px;
  }

  .proInfo1 {
    height: auto;
    border-bottom: none;
    margin-bottom: 20px;
  }

  .in1Top {
    width: 100%;
    text-align: center;
    font-size: 18px;
    padding-bottom: 12px;
    margin-bottom: 0;
    background: #F5F5F7;
  }

  .in1Main {
    display: block;
    height: auto;
  }

  .i1Left {
    height: 410px;
    width: 100%;
    border-right: none;
  }

  .i1Right {
    height: auto;
    width: 100%;
    padding: 20px 32px 15px;
    box-sizing: border-box;
  }

  .i1rName {
    font-size: 16px;
    margin-bottom: 22px;
  }

  .i1rLine1 {
    margin-bottom: 12px;
  }

  .rl1Left {
    width: 84px;
    height: 23px;
    font-size: 12px;
  }

  .rl1Right {
    height: 23px;
    font-size: 12px;
  }

  .proInfo2 {
    height: auto;
    border-bottom: none;
    margin-bottom: 20px;
  }

  .in2Top {
    width: 100%;
    text-align: center;
    font-size: 18px;
    padding-bottom: 12px;
    margin-bottom: 0;
    background: #F5F5F7;
  }

  .in2Main {
    display: block;
    height: auto;
  }

  .i2Left {
    height: 410px;
    width: 100%;
    border-right: none;
  }

  .i2Right {
    height: auto;
    width: 100%;
    padding: 20px 32px 15px;
    box-sizing: border-box;
  }

  .i2rName {
    font-size: 16px;
    margin-bottom: 22px;
  }

  .i2rLine1 {
    margin-bottom: 12px;
  }

  .rl2Left {
    width: 130px;
    height: 23px;
    font-size: 12px;
  }

  .rl2Right {
    height: 23px;
    font-size: 12px;
  }

  .rightLine {
    width: 260px;
  }

  .leftLine {
    width: 106px;
  }
}

@media (min-width: 830px) {
  .ab1Img {
    display: block;
  }

  .ab1Img2 {
    display: none;
  }
}
</style>